import styled from 'styled-components';

import Button from 'components/Button';
import { MainWrapper } from 'legacyComponents/styled/lib';

export const ButtonStyled = styled(Button)`
  margin: ${props =>
    `${props.theme.spacing.default} ${props.theme.spacing.small} ${props.theme.spacing.medium}`};
`;

export const ProjectNameWrapper = styled(MainWrapper)`
  display: flex;
  padding-top: ${props => props.theme.spacing.default};
  justify-content: space-between;
  flex-wrap: wrap;
`;

const circleSize = '2rem';
export const CircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${circleSize};
  max-width: ${circleSize};
  min-height: ${circleSize};
  max-height: ${circleSize};
  border: 1px solid ${props => props.theme.color[props.color]};
  border-radius: ${circleSize};
  margin-right: ${props => (props.large ? 0 : props.theme.spacing.small)};
  margin-bottom: ${props => (props.large ? '4rem' : 0)};
  transform: scale(${props => (props.large ? 3 : 1)});

  svg {
    path {
      fill: ${props => props.theme.color[props.color]};
    }
  }
`;

export const SpanLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  font-weight: ${props => props.theme.font.weight.xbold};
`;
